export default __webpack_public_path__ + "static/media/white-logo.e4d9080e.svg";